import _extends from 'babel-runtime/helpers/extends';
//
//
//
//
//
//
//
//
//
//

/** 常用图片预览创建组件 */
import VuePictureViewer from '@/components/vuePictureViewer/index';
import { mapGetters } from 'vuex';
import { removeAuth } from '@/utils/auth';

export default {
  name: 'App',
  components: {
    VuePictureViewer: VuePictureViewer
  },
  data: function data() {
    return {
      showPreviewImg: false,
      previewIndex: 0,
      previewImgs: []
    };
  },

  computed: _extends({}, mapGetters(['activeIndex'])),
  watch: {
    $route: function $route(to, from) {
      this.showPreviewImg = false; //切换页面隐藏图片预览
      this.$store.commit('SET_ACTIVEINDEX', to.path);
      // 如果没有存 获取一下
      // let paths = to.path.split('/')
      // if (paths.length >= 3) {
      //   console.log(paths)
      //   paths.splice(0, 2)
      //   this.$store.commit('SET_ACTIVEINDEX', paths.length == 1 ? paths[0] : paths.join('/'))
      // }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.addBus();
    // 检测浏览器路由改变页面不刷新问题,hash模式的工作原理是hashchange事件
    window.addEventListener('hashchange', function () {
      var currentPath = window.location.hash.slice(1);
      if (_this.$route.path !== currentPath) {
        _this.$router.push(currentPath);
      }
    }, false);
  },

  methods: {
    addBus: function addBus() {
      var self = this;
      this.$bus.on('preview-image-bus', function (data) {
        self.previewIndex = data.index;
        self.previewImgs = data.data;
        self.showPreviewImg = true;
      });
    },

    moveEvent: function moveEvent() {
      var path = ['/login', '/operateWatchTableShow', '/operateWatchTableShowBJ', '/operateWatchTableShowCD'];
      if (!path.includes(this.$route.path)) {
        clearTimeout(this.timmer);
        this.init();
      }
    },
    init: function init() {
      var _this2 = this;

      this.timmer = setTimeout(function () {
        sessionStorage.clear();
        removeAuth();
        _this2.$router.push({
          path: '/login'
        });
      }, 1000 * 60 * 60 * 4);
    }
  }
};